import { useCallback, useEffect, useState } from 'react'
import queryString from 'query-string'
import { getSubmissionStatus } from 'services/receipt'

const getToken = (tokenName = 'token') => {
  try {
    let qs = queryString.parse(window.location.search)
    if (qs[tokenName]) {
      return qs[tokenName]
    } else {
      return null
    }
  } catch (e) {
    return null
  }
}

export const useSubmissionStatus = (breakId, step, handleInstantWinEvent) => {
  const [previousSubmissionStatus, setPreviousSubmissionStatus] = useState(null)
  const [loaded, setLoaded] = useState(false)

  const attemptToRetrievePendingSubmission = useCallback(async () => {
    try {
      const theToken = getToken('token')
      if (theToken) {
        const statusResult = await getSubmissionStatus({
          breakId,
          stepId: step.id,
          token: theToken,
          receiptId: step.receiptVerificationCampaign.id,
        })

        if (typeof statusResult.status === 'string') {
          const chosenReward = step.receiptVerificationCampaign.rewards.find(
            reward => reward.id === statusResult.rewardId,
          )

          setPreviousSubmissionStatus({
            status: statusResult.status,
            reward: chosenReward,
            fullResponse: statusResult,
          })

          setLoaded(true)
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoaded(true)
    }
  }, [breakId, step])

  useEffect(() => {
    attemptToRetrievePendingSubmission()
  }, [attemptToRetrievePendingSubmission])

  useEffect(() => {
    if (handleInstantWinEvent && previousSubmissionStatus) {
      handleInstantWinEvent({
        eventName:
          `receipt-submission-status-${previousSubmissionStatus.status}`.toLowerCase(),
        context: {
          receiptStatusResult: previousSubmissionStatus.fullResponse,
          stepId: step.id,
        },
      })
    }
  }, [previousSubmissionStatus, handleInstantWinEvent, step.id])

  return { previousSubmissionStatus, loaded }
}
